import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, IconButton, Paper, Tooltip, Typography, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { DocumentsType } from 'v2-types/order';
import { FileType } from '../../../types';
import { DataRow } from './components/DataRow';

type Props = {
  document: DocumentsType,
  handleDownload: (link: string, fileName: string) => void,
  viewFile: (fileId: string) => void,
  onEditExpectedFrom: () => void,
  onDeleteDocument: () => void,
  onUploadDocumentFiles: () => void,
  onDeleteFile: (file: FileType) => void
}

export const UploadRow: React.FC<Props> = ({
  document: { _id: documentId, description, archives, data },
  handleDownload,
  viewFile,
  onEditExpectedFrom,
  onDeleteDocument,
  onUploadDocumentFiles,
  onDeleteFile
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const findPartyArchiveByPartyId = (partyId: string) => {
    return archives.find(({ _id }) => _id === partyId)?.files ?? [];
  };

  return (
    <Paper elevation={2} key={documentId}>
      <Box
        style={{
          backgroundColor: "#f8fafb",
          minHeight: theme.spacing(6),
          display: "flex",
          alignItems: "center",
          borderBottom: "1px solid lightgray",
          justifyContent: "space-between",
          flexWrap: 'wrap',
          padding: theme.spacing(0.5, 1, 0.5, 3),
          gap: theme.spacing(0.5)
        }}
      >
        <Typography variant="body1" color="primary" style={{ minWidth: 0, overflowWrap: 'anywhere' }}>{description}</Typography>
        <Box style={{ display: "flex", gap: theme.spacing(0.5), marginLeft: 'auto' }}>
          <Tooltip title={data.length === 0 ? t('documents:add-parties-first-tooltip') : t('documents:upload-files-tooltip')}>
            <IconButton
              size="small"
              style={{ padding: isMobile ? theme.spacing(1.5) : undefined }}
              onClick={() => data.length > 0 && onUploadDocumentFiles()}
            >
              <FontAwesomeIcon icon="upload" />
            </IconButton>
          </Tooltip>
          <Tooltip title={t('common:edit-parties')}>
            <IconButton
              size="small"
              style={{ padding: isMobile ? theme.spacing(1.5) : undefined }}
              onClick={onEditExpectedFrom}
            >
              <FontAwesomeIcon icon="edit" />
            </IconButton>
          </Tooltip>
          <IconButton
            size="small"
            style={{ padding: isMobile ? theme.spacing(1.5) : undefined }}
            onClick={onDeleteDocument}
          >
            <FontAwesomeIcon icon="trash" />
          </IconButton>
        </Box>
      </Box>
      {data.length > 0 && (
        <Box style={{ padding: theme.spacing(0, 1, 0, isMobile ? 1 : 3) }}>
          {data.filter(({ kind }) => kind === "party").map((dataEntry, index) => (
            <DataRow
              showBottomBorder={data.length > 0}
              dataEntry={dataEntry}
              viewFile={viewFile}
              handleDownload={handleDownload}
              findPartyArchiveByPartyId={findPartyArchiveByPartyId}
              onDeleteFile={onDeleteFile}
              documentId={documentId}
            />
          ))}
        </Box>
      )}
    </Paper>
  );
};
